const API_URL = "/api";
const API_VERSION = "v1";
class ApiService {
    apiUrl(uri) {
        //return `${API_URL}/${API_VERSION}/${uri}`;
        return `${uri}`;
    }
}
export default new ApiService();
